module.exports = __webpack_public_path__ + "img/icon-pedidos-entrega-de-cambio.d279a5ce.svg";